function AlternativeOrderTracker(analytics) {
    'use strict';

    this.analytics      = analytics;
    this.$optionButtons = $('.catalog-order__option');
    this.$optionType    = $('.catalog-order__number a');
}

AlternativeOrderTracker.prototype = {
    init: function () {
        'use strict';

        if (!this.$optionButtons.length) {
            return this;
        }

        this.initOrderOptionView()
            .initOrderOptionSelect();
    },

    /**
     * @return {AlternativeOrderTracker}
     */
    initOrderOptionView: function() {
        'use strict';
        this.$optionButtons.on('click', $.proxy(this.trackOrderOptionTypeView, this));
        return this;
    },

    /**
     * @return {AlternativeOrderTracker}
     */
    initOrderOptionSelect: function () {
        'use strict';
        this.$optionType.on('click', $.proxy(this.trackOrderOptionTypeSelection, this));
        return this;
    },

    /**
     * @param  {Object} $anchor
     * @return {String}
     */
    getOrderTypeFromButton: function ($button) {
        'use strict';
        var content = $button.data('content');
        return content.slice(content.lastIndexOf('-') + 1);
    },

    /**
     * @param  {Object} $anchor
     * @return {String}
     */
    getOrderTypeFromAnchor: function ($anchor) {
        'use strict';
        return $anchor.data('type');
    },

    /**
     * @param {Object} event
     * @return {AlternativeOrderTracker}
     */
    trackOrderOptionTypeView: function (event) {
        'use strict';
        var $button = $(event.currentTarget);
        this.analytics.track('Order Method', 'view', this.getOrderTypeFromButton($button), 1);
        return this;
    },

    /**
     * @param {Object} event
     * @return {AlternativeOrderTracker}
     */
    trackOrderOptionTypeSelection: function (event) {
        'use strict';
        var $a = $(event.currentTarget);
        this.analytics.track('Order Method', 'select', this.getOrderTypeFromAnchor($a), 1);
        return this;
    }
};

export default AlternativeOrderTracker;